import React from "react";
import { Accordion, AccordionItem } from "@nextui-org/react";
import picture2 from '../picture2.jpeg'
import picture3 from '../picture3.jpeg'
import picture4 from '../picture4.jpeg'
import picture5 from '../picture5.jpeg'
import picture6 from '../picture6.jpeg'
import { useState } from "react";

function Feature() {

    const defaultContent1 ="Receive already reviewed information about the most captivating events in crypto world. The professional analytics will allow you to easily make money";
    const defaultContent2 ="All activities will have an “auto update feed”, which will be monitored by the NFD team so that you wont miss important changes or additions to any activity. Stay up to date!";
    const defaultContent3 ="We have implemented an internal calendar functionality that will synchronize all your “Activities” in NFD, all their deadlines and important events. You can also add your token";
    const defaultContent4 ="Create a project card, set up data parsing in just 2 minutes and get only the necessary information concerning any crypto project.";
    const defaultContent5 ="Make your own list of influencers, funds or degen accounts on Twitter and monitor their new subscriptions and where those subscriptions match each other. Be the first to find an alpha.";
    // const imagePath = '../picture2.jpeg';
    const [picture, setPicture] = useState(picture2);


    return (
        <div className="Feature" id="features">
            <div style={{ width: '100%', height: 'auto', paddingTop: '200px', paddingBottom: '220px' }}>
                <h1 style={{ fontSize: '60px', fontWeight: 800, }}>Use all the benefits of NFD</h1>
                <br></br>
                <h2 style={{ fontSize: '30px', color: '#737373', fontWeight: 300, paddingLeft: '13%', paddingRight: '13%' }}>Unlock the next level of control with customizable real-time feeds, charts, watchlists, and alerts with NFD.gg</h2>
            </div>


            <div style={{ display: 'flex', justifyContent: 'center',paddingBottom:'500px'}}>
                <div style={{ width: '50%', height: 'auto',paddingLeft:'70px' }}>
                    <Accordion variant="splitted">
                        <AccordionItem key="1" aria-label="Accordion 1" title="Activities" onPress={()=>{setPicture(picture2)}} style={{textAlign:'left'}}>
                            {defaultContent1}
                            <div class='content-center pt-7'>
                              <img class=" items-center content-center sm:w-3/4 md:w-3/4 lg:hidden" src={picture2} alt="Picture the" />
                            </div>
                        </AccordionItem>
                        <AccordionItem key="2" aria-label="Accordion 2" title="Auto-Update feed" onPress={()=>{setPicture(picture3)}} style={{textAlign:'left'}} >
                            {defaultContent2}
                            <div class='content-center pt-7'>
                              <img class=" items-center content-center sm:w-3/4 md:w-3/4 lg:hidden" src={picture3} alt="Picture the" />
                            </div>
                        </AccordionItem>
                        <AccordionItem key="3" aria-label="Accordion 3" title="Calendar" onPress={()=>{setPicture(picture4)}} style={{textAlign:'left'}}>
                            {defaultContent3}
                            <div class='content-center pt-7'>
                              <img class=" items-center content-center sm:w-3/4 md:w-3/4 lg:hidden" src={picture4} alt="Picture the" />
                            </div>
                        </AccordionItem>
                        <AccordionItem key="4" aria-label="Accordion 3" title="Aggregator" onPress={()=>{setPicture(picture5)}} style={{textAlign:'left'}}>
                            {defaultContent4}
                            <div class='content-center pt-7'>
                              <img class=" items-center content-center sm:w-3/4 md:w-3/4 lg:hidden" src={picture5} alt="Picture the" />
                            </div>
                        </AccordionItem>
                        <AccordionItem key="5" aria-label="Accordion 3" title="Alpha Search" onPress={()=>{setPicture(picture6)}} style={{textAlign:'left'}}>
                            {defaultContent5}
                            <div class='content-center pt-7'>
                              <img class=" items-center content-center sm:w-3/4 md:w-3/4 lg:hidden" src={picture6} alt="Picture the" />
                            </div>
                        </AccordionItem>
                    </Accordion>

                </div>

                <div class=" sm:hidden lg:block"style={{ width: '60%', height: 'auto',paddingLeft:'10%' }}>
                   <img src={picture} alt="Description"  style={{height:'450px'}}/>
                </div>
            </div>
        </div>
    )


}

export default Feature;